import { useRef } from 'react';
import { getSelectionPosition, setSelectionPosition, useEventCallback, } from '../../../../foundation';
/**
 * bind with ref, let input can always focus at end of latest character
 */
export var useFixedEndSelection = function () {
    var ref = useRef(null);
    var keypadModeFixedAtLatest = useEventCallback(function () {
        var _a;
        var _b = getSelectionPosition(ref), position = _b.position, isSelectRange = _b.isSelectRange;
        var value = ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.value) || '';
        if (isSelectRange || position.start < value.length) {
            var targetPosition = value.length;
            setSelectionPosition(ref, {
                start: targetPosition,
                end: targetPosition,
                scrollIntoView: true,
            });
        }
    });
    var onKeyDown = function (e) {
        if ([
            'ArrowUp',
            'ArrowLeft',
            'ArrowRight',
            'ArrowDown',
            'PageUp',
            'PageDown',
            'Home',
            'End',
        ].includes(e.key)) {
            e.preventDefault();
            e.stopPropagation();
        }
        keypadModeFixedAtLatest();
    };
    return {
        ref: ref,
        onFocus: keypadModeFixedAtLatest,
        onClick: keypadModeFixedAtLatest,
        onKeyDown: onKeyDown,
    };
};
